import { render, staticRenderFns } from "./MessageContentPreview.vue?vue&type=template&id=10bb1cd2&scoped=true&"
import script from "./MessageContentPreview.vue?vue&type=script&lang=js&"
export * from "./MessageContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./MessageContentPreview.vue?vue&type=style&index=0&id=10bb1cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb1cd2",
  null
  
)

export default component.exports